import styled from 'styled-components'

export default styled.section`
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 100px;
`
